/* eslint-disable import/no-unresolved */
const RobotoBlackTtf = require('./Roboto-Black.ttf').default;
const RobotoBlackItalicTtf = require('./Roboto-BlackItalic.ttf').default;
const RobotoBoldTtf = require('./Roboto-Bold.ttf').default;
const RobotoBoldItalicTtf = require('./Roboto-BoldItalic.ttf').default;
const RobotoItalicTtf = require('./Roboto-Italic.ttf').default;
const RobotoLightTtf = require('./Roboto-Light.ttf').default;
const RobotoLightItalicTtf = require('./Roboto-LightItalic.ttf').default;
const RobotoMediumTtf = require('./Roboto-Medium.ttf').default;
const RobotoMediumItalicTtf = require('./Roboto-MediumItalic.ttf').default;
const RobotoRegularTtf = require('./Roboto-Regular.ttf').default;
const RobotoThinTtf = require('./Roboto-Thin.ttf').default;
const RobotoThinItalicTtf = require('./Roboto-ThinItalic.ttf').default;

export const RobotoThin = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 100,
  src: `url('${RobotoThinTtf}') format('truetype')`,
};

export const RobotoThinItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontWeight: 100,
  src: `url('${RobotoThinItalicTtf}') format('truetype')`,
};

export const RobotoLight = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 300,
  src: `url('${RobotoLightTtf}') format('truetype')`,
};

export const RobotoLightItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontWeight: 300,
  src: `url('${RobotoLightItalicTtf}') format('truetype')`,
};

export const RobotoRegular = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `url('${RobotoRegularTtf}') format('truetype')`,
};

export const RobotoRegularItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontWeight: 400,
  src: `url('${RobotoItalicTtf}') format('truetype')`,
};

export const RobotoMedium = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 600,
  src: `url('${RobotoMediumTtf}') format('truetype')`,
};

export const RobotoMediumItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontWeight: 600,
  src: `url('${RobotoMediumItalicTtf}') format('truetype')`,
};

export const RobotoBold = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 700,
  src: `url('${RobotoBoldTtf}') format('truetype')`,
};

export const RobotoBoldItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontWeight: 700,
  src: `url('${RobotoBoldItalicTtf}') format('truetype')`,
};

export const RobotoBlack = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 900,
  src: `url('${RobotoBlackTtf}') format('truetype')`,
};

export const RobotoBlackItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontWeight: 900,
  src: `url('${RobotoBlackItalicTtf}') format('truetype')`,
};
